import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api, apiErrorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function InlineNewsletterSignup({ source = "article_inline" }) {
  const { user } = useAuth();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/newsletter/subscribe", {
        email: user ? undefined : email,
        source,
        url: window.location.href,
      });
      toast.success("Готово! Благодарим за абонамента.");
      setDone(true);
      setEmail("");
    } catch (err) {
      toast.error(apiErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="my-10 border border-[#C47A35]/35 bg-[#F3E8DB] px-6 sm:px-8 py-8" data-testid="article-inline-newsletter-form">
      <p className="text-xs font-extrabold uppercase tracking-wide text-[#A6631F]">Metri.bg Бюлетин за новини</p>
      <h4 className="mt-2 font-serif text-2xl font-bold text-[#10243A]">Новини за имотния пазар — веднъж седмично</h4>
      <p className="mt-2 text-sm text-[#20252B]">Получавайте най-важното от пазара на имоти, лихвите и инвестициите директно в пощата си.</p>
      {done ? (
        <p className="mt-4 text-sm font-semibold text-[#16836B]" data-testid="article-inline-newsletter-success">Абонирахте се успешно. Благодарим!</p>
      ) : (
        <form onSubmit={submit} className="mt-4 flex flex-col sm:flex-row gap-3">
          {!user ? (
            <Input
              type="email"
              required
              placeholder="Вашият имейл"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="h-11 text-base bg-white"
              data-testid="article-inline-newsletter-email-input"
            />
          ) : (
            <p className="text-sm text-[#66717B] flex-1 flex items-center">Ще използваме имейла на профила ви: {user.email}</p>
          )}
          <Button
            type="submit"
            disabled={loading}
            className="h-11 bg-[#10243A] hover:bg-[#C47A35] text-white text-sm font-semibold whitespace-nowrap transition-colors"
            data-testid="article-inline-newsletter-submit-btn"
          >
            {loading ? "Изпращане..." : "Абонирай се"}
          </Button>
        </form>
      )}
    </div>
  );
}
